import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import MaintenanceInfoPage from './pages/Maintenance/MaintenanceInfoPage'
import reportWebVitals from './reportWebVitals'
import Routes from './Routes'
import i18n from './utils/i18n'
import { queryClient } from './config/queryClient'
import ErrorBoundary from './components/layout/ErrorBoundry'

import './styles.css'
import CssBaseline from '@mui/material/CssBaseline'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Check maintenance mode from both build-time and runtime configuration
const isMaintenanceMode =
  process.env.REACT_APP_MAINTENANCE_MODE === 'TRUE' ||
  window.__RUNTIME_CONFIG__?.MAINTENANCE_MODE === 'TRUE'

if (isMaintenanceMode) {
  root.render(
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <I18nextProvider i18n={i18n}>
          <Suspense>
            <CssBaseline />
            <MaintenanceInfoPage />
          </Suspense>
        </I18nextProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  )
} else {
  root.render(
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <I18nextProvider i18n={i18n}>
          <Suspense>
            <CssBaseline />
            <Routes />
            <ToastContainer
              position="bottom-center"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              role="region"
              aria-label="notifications"
            />
          </Suspense>
        </I18nextProvider>
        {process.env.NODE_ENV === 'development' && !(window as any).Cypress && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </ErrorBoundary>
    </QueryClientProvider>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
